import { memo } from 'react';
import { Element } from '@zmedia/bm-soccer-ui/components';
import styles from './styles.module.scss';

const Loading = () => {
    return (
        <Element className={styles['loading-content']}>
            Đang tải ...
        </Element>
    );
};

export default memo(Loading);
